export default __webpack_public_path__ + "static/media/Axe_7.a99e6d59.png";